const tsDataEnglish = {
  scale1: {
    "Ambiguity & Series": 0.0,
    Apostrophes: 0.0,
    "Colons & Semicolons": 0.0,
    "Parenthetical Elements": 0.0179856,
    "Unnecessary Commas": 0.0215827,
    "Faulty Coordination & Subordination": 0.0,
    "Fragments & Fused Sentences": 0.0143885,
    "Misplaced Modifiers": 0.0,
    Parallelism: null,
    "Participial Phrases": 0.0,
    "Relative Pronouns": 0.25,
    "Verb Tense & Pronoun Person": 0.0107914,
    "Adjectives & Adverbs": 0.0,
    "Comparatives & Superlatives": 0.0,
    "Confusing Pairs": 0.0215827,
    "Forming Verbs": 0.0,
    Idiom: 0.0,
    Prepositions: 0.0,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.0431655,
    "Subject-Verb Agreement": 0.0,
    Conjunctions: 0.0215827,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.129496,
    "Word Choice": 0.00269784,
    "Introductions & Conclusions": 0.0,
    "Paragraph Division": 0.0,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.0,
    "Sentence Sequence": 0.0,
    Transitions: 0.00431655,
    "Accomplish Purpose": 0.0,
    "Author's Purpose": 0.00863309,
    Relevance: 0.0,
    "Writer's Goal": 0.0
  },
  scale2: {
    "Ambiguity & Series": 0.09375,
    Apostrophes: 0.0714286,
    "Colons & Semicolons": 0.0555556,
    "Parenthetical Elements": 0.0327381,
    "Unnecessary Commas": 0.115079,
    "Faulty Coordination & Subordination": 0.0,
    "Fragments & Fused Sentences": 0.0446429,
    "Misplaced Modifiers": 0.333333,
    Parallelism: null,
    "Participial Phrases": 0.166667,
    "Relative Pronouns": 0.0,
    "Verb Tense & Pronoun Person": 0.0744048,
    "Adjectives & Adverbs": 0.0892857,
    "Comparatives & Superlatives": 0.0,
    "Confusing Pairs": 0.0,
    "Forming Verbs": 0.0208333,
    Idiom: 0.0,
    Prepositions: 0.00892857,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.0625,
    "Subject-Verb Agreement": 0.015873,
    Conjunctions: 0.0285714,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.160714,
    "Word Choice": 0.0267857,
    "Introductions & Conclusions": 0.113095,
    "Paragraph Division": 0.0,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.0654762,
    "Sentence Sequence": 0.0,
    Transitions: 0.0107143,
    "Accomplish Purpose": 0.0,
    "Author's Purpose": 0.0869048,
    Relevance: 0.0,
    "Writer's Goal": 0.0833333
  },
  scale3: {
    "Ambiguity & Series": 0.119565,
    Apostrophes: 0.256522,
    "Colons & Semicolons": 0.0724638,
    "Parenthetical Elements": 0.0173913,
    "Unnecessary Commas": 0.138043,
    "Faulty Coordination & Subordination": 0.0,
    "Fragments & Fused Sentences": 0.0565217,
    "Misplaced Modifiers": 0.26087,
    Parallelism: null,
    "Participial Phrases": 0.217391,
    "Relative Pronouns": 0.0869565,
    "Verb Tense & Pronoun Person": 0.158696,
    "Adjectives & Adverbs": 0.0695652,
    "Comparatives & Superlatives": 0.391304,
    "Confusing Pairs": 0.0,
    "Forming Verbs": 0.0,
    Idiom: 0.0,
    Prepositions: 0.0521739,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.0521739,
    "Subject-Verb Agreement": 0.0637681,
    Conjunctions: 0.0234783,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.18913,
    "Word Choice": 0.0146739,
    "Introductions & Conclusions": 0.132609,
    "Paragraph Division": 0.0,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.0521739,
    "Sentence Sequence": 0.00869565,
    Transitions: 0.0171014,
    "Accomplish Purpose": 0.00434783,
    "Author's Purpose": 0.053913,
    Relevance: 0.0,
    "Writer's Goal": 0.1
  },
  scale4: {
    "Ambiguity & Series": 0.181223,
    Apostrophes: 0.326316,
    "Colons & Semicolons": 0.150794,
    "Parenthetical Elements": 0.0567251,
    "Unnecessary Commas": 0.236257,
    "Faulty Coordination & Subordination": 0.0,
    "Fragments & Fused Sentences": 0.0631579,
    "Misplaced Modifiers": 0.452381,
    Parallelism: null,
    "Participial Phrases": 0.0714286,
    "Relative Pronouns": 0.178571,
    "Verb Tense & Pronoun Person": 0.185965,
    "Adjectives & Adverbs": 0.217154,
    "Comparatives & Superlatives": 0.5,
    "Confusing Pairs": 0.0,
    "Forming Verbs": 0.00436681,
    Idiom: 0.00701754,
    Prepositions: 0.0327485,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.100877,
    "Subject-Verb Agreement": 0.0547758,
    Conjunctions: 0.0638596,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.257895,
    "Word Choice": 0.0412281,
    "Introductions & Conclusions": 0.111696,
    "Paragraph Division": 0.0,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.0830409,
    "Sentence Sequence": 0.0134503,
    Transitions: 0.031423,
    "Accomplish Purpose": 0.00818713,
    "Author's Purpose": 0.0996491,
    Relevance: 0.0,
    "Writer's Goal": 0.204678
  },
  scale5: {
    "Ambiguity & Series": 0.216524,
    Apostrophes: 0.377839,
    "Colons & Semicolons": 0.145,
    "Parenthetical Elements": 0.0898142,
    "Unnecessary Commas": 0.208133,
    "Faulty Coordination & Subordination": 0.0,
    "Fragments & Fused Sentences": 0.0849966,
    "Misplaced Modifiers": 0.41,
    Parallelism: null,
    "Participial Phrases": 0.18,
    "Relative Pronouns": 0.29,
    "Verb Tense & Pronoun Person": 0.166552,
    "Adjectives & Adverbs": 0.239963,
    "Comparatives & Superlatives": 0.57,
    "Confusing Pairs": 0.0211058,
    "Forming Verbs": 0.011396,
    Idiom: 0.0158293,
    Prepositions: 0.0925671,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.120613,
    "Subject-Verb Agreement": 0.0613673,
    Conjunctions: 0.0664831,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.244666,
    "Word Choice": 0.0658121,
    "Introductions & Conclusions": 0.185478,
    "Paragraph Division": 0.00412939,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.207158,
    "Sentence Sequence": 0.041638,
    Transitions: 0.0843772,
    "Accomplish Purpose": 0.0550585,
    "Author's Purpose": 0.129525,
    Relevance: 0.01,
    "Writer's Goal": 0.285616
  },
  scale6: {
    "Ambiguity & Series": 0.209903,
    Apostrophes: 0.364702,
    "Colons & Semicolons": 0.169872,
    "Parenthetical Elements": 0.139109,
    "Unnecessary Commas": 0.258722,
    "Faulty Coordination & Subordination": 0.00641026,
    "Fragments & Fused Sentences": 0.115948,
    "Misplaced Modifiers": 0.333333,
    Parallelism: null,
    "Participial Phrases": 0.217949,
    "Relative Pronouns": 0.266026,
    "Verb Tense & Pronoun Person": 0.208297,
    "Adjectives & Adverbs": 0.300694,
    "Comparatives & Superlatives": 0.551282,
    "Confusing Pairs": 0.0460276,
    "Forming Verbs": 0.0624327,
    Idiom: 0.0474934,
    Prepositions: 0.0932278,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.180372,
    "Subject-Verb Agreement": 0.121861,
    Conjunctions: 0.120727,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.324978,
    "Word Choice": 0.0897464,
    "Introductions & Conclusions": 0.181618,
    "Paragraph Division": 0.0527704,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.22105,
    "Sentence Sequence": 0.0772501,
    Transitions: 0.11074,
    "Accomplish Purpose": 0.0694811,
    "Author's Purpose": 0.170859,
    Relevance: 0.0128205,
    "Writer's Goal": 0.335239
  },
  scale7: {
    "Ambiguity & Series": 0.232877,
    Apostrophes: 0.346838,
    "Colons & Semicolons": 0.215138,
    "Parenthetical Elements": 0.172445,
    "Unnecessary Commas": 0.271664,
    "Faulty Coordination & Subordination": 0.0559284,
    "Fragments & Fused Sentences": 0.152448,
    "Misplaced Modifiers": 0.393736,
    Parallelism: null,
    "Participial Phrases": 0.210291,
    "Relative Pronouns": 0.265101,
    "Verb Tense & Pronoun Person": 0.247695,
    "Adjectives & Adverbs": 0.327187,
    "Comparatives & Superlatives": 0.50783,
    "Confusing Pairs": 0.120374,
    "Forming Verbs": 0.0847286,
    Idiom: 0.101286,
    Prepositions: 0.157447,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.242176,
    "Subject-Verb Agreement": 0.172488,
    Conjunctions: 0.153123,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.318141,
    "Word Choice": 0.129236,
    "Introductions & Conclusions": 0.196468,
    "Paragraph Division": 0.0601221,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.294637,
    "Sentence Sequence": 0.143098,
    Transitions: 0.153383,
    "Accomplish Purpose": 0.112907,
    "Author's Purpose": 0.207817,
    Relevance: 0.0402685,
    "Writer's Goal": 0.345215
  },
  scale8: {
    "Ambiguity & Series": 0.244639,
    Apostrophes: 0.395037,
    "Colons & Semicolons": 0.25523,
    "Parenthetical Elements": 0.201852,
    "Unnecessary Commas": 0.317753,
    "Faulty Coordination & Subordination": 0.108787,
    "Fragments & Fused Sentences": 0.186037,
    "Misplaced Modifiers": 0.408647,
    Parallelism: null,
    "Participial Phrases": 0.262204,
    "Relative Pronouns": 0.365411,
    "Verb Tense & Pronoun Person": 0.261,
    "Adjectives & Adverbs": 0.375679,
    "Comparatives & Superlatives": 0.446304,
    "Confusing Pairs": 0.177654,
    "Forming Verbs": 0.150395,
    Idiom: 0.148519,
    Prepositions: 0.193222,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.28837,
    "Subject-Verb Agreement": 0.204543,
    Conjunctions: 0.203881,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.358,
    "Word Choice": 0.167556,
    "Introductions & Conclusions": 0.229704,
    "Paragraph Division": 0.0941481,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.298519,
    "Sentence Sequence": 0.187185,
    Transitions: 0.18521,
    "Accomplish Purpose": 0.159444,
    "Author's Purpose": 0.246607,
    Relevance: 0.0808926,
    "Writer's Goal": 0.378741
  },
  scale9: {
    "Ambiguity & Series": 0.279262,
    Apostrophes: 0.454466,
    "Colons & Semicolons": 0.27769,
    "Parenthetical Elements": 0.228538,
    "Unnecessary Commas": 0.368503,
    "Faulty Coordination & Subordination": 0.208861,
    "Fragments & Fused Sentences": 0.210557,
    "Misplaced Modifiers": 0.370253,
    Parallelism: null,
    "Participial Phrases": 0.280063,
    "Relative Pronouns": 0.412975,
    "Verb Tense & Pronoun Person": 0.294896,
    "Adjectives & Adverbs": 0.440507,
    "Comparatives & Superlatives": 0.544304,
    "Confusing Pairs": 0.220205,
    "Forming Verbs": 0.202284,
    Idiom: 0.197912,
    Prepositions: 0.230307,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.327857,
    "Subject-Verb Agreement": 0.248985,
    Conjunctions: 0.253991,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.40902,
    "Word Choice": 0.195345,
    "Introductions & Conclusions": 0.25728,
    "Paragraph Division": 0.127378,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.345998,
    "Sentence Sequence": 0.226479,
    Transitions: 0.217838,
    "Accomplish Purpose": 0.177755,
    "Author's Purpose": 0.300812,
    Relevance: 0.117089,
    "Writer's Goal": 0.446259
  },
  scale10: {
    "Ambiguity & Series": 0.32122,
    Apostrophes: 0.454961,
    "Colons & Semicolons": 0.316064,
    "Parenthetical Elements": 0.231131,
    "Unnecessary Commas": 0.3911,
    "Faulty Coordination & Subordination": 0.184739,
    "Fragments & Fused Sentences": 0.225259,
    "Misplaced Modifiers": 0.415261,
    Parallelism: null,
    "Participial Phrases": 0.346988,
    "Relative Pronouns": 0.453012,
    "Verb Tense & Pronoun Person": 0.329556,
    "Adjectives & Adverbs": 0.454538,
    "Comparatives & Superlatives": 0.609639,
    "Confusing Pairs": 0.265918,
    "Forming Verbs": 0.214703,
    Idiom: 0.238621,
    Prepositions: 0.287945,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.377182,
    "Subject-Verb Agreement": 0.279439,
    Conjunctions: 0.279617,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.427887,
    "Word Choice": 0.209881,
    "Introductions & Conclusions": 0.32343,
    "Paragraph Division": 0.133435,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.41865,
    "Sentence Sequence": 0.234749,
    Transitions: 0.250467,
    "Accomplish Purpose": 0.220847,
    "Author's Purpose": 0.308513,
    Relevance: 0.128514,
    "Writer's Goal": 0.448994
  },
  scale11: {
    "Ambiguity & Series": 0.345568,
    Apostrophes: 0.491409,
    "Colons & Semicolons": 0.345658,
    "Parenthetical Elements": 0.243883,
    "Unnecessary Commas": 0.441987,
    "Faulty Coordination & Subordination": 0.195677,
    "Fragments & Fused Sentences": 0.238385,
    "Misplaced Modifiers": 0.493743,
    Parallelism: null,
    "Participial Phrases": 0.324232,
    "Relative Pronouns": 0.485779,
    "Verb Tense & Pronoun Person": 0.381753,
    "Adjectives & Adverbs": 0.535143,
    "Comparatives & Superlatives": 0.588168,
    "Confusing Pairs": 0.281191,
    "Forming Verbs": 0.247145,
    Idiom: 0.269416,
    Prepositions: 0.299347,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.402629,
    "Subject-Verb Agreement": 0.316128,
    Conjunctions: 0.31556,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.474296,
    "Word Choice": 0.233247,
    "Introductions & Conclusions": 0.333333,
    "Paragraph Division": 0.150997,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.463918,
    "Sentence Sequence": 0.250481,
    Transitions: 0.275349,
    "Accomplish Purpose": 0.221787,
    "Author's Purpose": 0.345443,
    Relevance: 0.139932,
    "Writer's Goal": 0.515945
  },
  scale12: {
    "Ambiguity & Series": 0.368034,
    Apostrophes: 0.498189,
    "Colons & Semicolons": 0.344309,
    "Parenthetical Elements": 0.263785,
    "Unnecessary Commas": 0.48332,
    "Faulty Coordination & Subordination": 0.271951,
    "Fragments & Fused Sentences": 0.249195,
    "Misplaced Modifiers": 0.50122,
    Parallelism: null,
    "Participial Phrases": 0.456098,
    "Relative Pronouns": 0.554268,
    "Verb Tense & Pronoun Person": 0.403944,
    "Adjectives & Adverbs": 0.597666,
    "Comparatives & Superlatives": 0.682927,
    "Confusing Pairs": 0.332752,
    "Forming Verbs": 0.268576,
    Idiom: 0.318822,
    Prepositions: 0.319292,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.447847,
    "Subject-Verb Agreement": 0.332249,
    Conjunctions: 0.348135,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.512577,
    "Word Choice": 0.23775,
    "Introductions & Conclusions": 0.359371,
    "Paragraph Division": 0.155889,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.492756,
    "Sentence Sequence": 0.270258,
    Transitions: 0.294875,
    "Accomplish Purpose": 0.228032,
    "Author's Purpose": 0.37612,
    Relevance: 0.173171,
    "Writer's Goal": 0.566038
  },
  scale13: {
    "Ambiguity & Series": 0.3672,
    Apostrophes: 0.486025,
    "Colons & Semicolons": 0.365504,
    "Parenthetical Elements": 0.252292,
    "Unnecessary Commas": 0.489448,
    "Faulty Coordination & Subordination": 0.252802,
    "Fragments & Fused Sentences": 0.276451,
    "Misplaced Modifiers": 0.603985,
    Parallelism: null,
    "Participial Phrases": 0.458281,
    "Relative Pronouns": 0.606476,
    "Verb Tense & Pronoun Person": 0.442288,
    "Adjectives & Adverbs": 0.572857,
    "Comparatives & Superlatives": 0.686177,
    "Confusing Pairs": 0.368602,
    "Forming Verbs": 0.2992,
    Idiom: 0.351816,
    Prepositions: 0.386387,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.49222,
    "Subject-Verb Agreement": 0.369243,
    Conjunctions: 0.345524,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.490268,
    "Word Choice": 0.267101,
    "Introductions & Conclusions": 0.375014,
    "Paragraph Division": 0.189883,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.498359,
    "Sentence Sequence": 0.278432,
    Transitions: 0.342107,
    "Accomplish Purpose": 0.262023,
    "Author's Purpose": 0.384882,
    Relevance: 0.175592,
    "Writer's Goal": 0.537796
  },
  scale14: {
    "Ambiguity & Series": 0.388315,
    Apostrophes: 0.524903,
    "Colons & Semicolons": 0.378747,
    "Parenthetical Elements": 0.272227,
    "Unnecessary Commas": 0.542586,
    "Faulty Coordination & Subordination": 0.261799,
    "Fragments & Fused Sentences": 0.290195,
    "Misplaced Modifiers": 0.58415,
    Parallelism: null,
    "Participial Phrases": 0.535174,
    "Relative Pronouns": 0.628228,
    "Verb Tense & Pronoun Person": 0.473664,
    "Adjectives & Adverbs": 0.68347,
    "Comparatives & Superlatives": 0.704363,
    "Confusing Pairs": 0.386876,
    "Forming Verbs": 0.317819,
    Idiom: 0.357592,
    Prepositions: 0.381188,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.500666,
    "Subject-Verb Agreement": 0.409802,
    Conjunctions: 0.38062,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.539051,
    "Word Choice": 0.29191,
    "Introductions & Conclusions": 0.406896,
    "Paragraph Division": 0.190783,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.543549,
    "Sentence Sequence": 0.311278,
    Transitions: 0.349956,
    "Accomplish Purpose": 0.238755,
    "Author's Purpose": 0.430678,
    Relevance: 0.204809,
    "Writer's Goal": 0.635699
  },
  scale15: {
    "Ambiguity & Series": 0.428755,
    Apostrophes: 0.542234,
    "Colons & Semicolons": 0.402851,
    "Parenthetical Elements": 0.27936,
    "Unnecessary Commas": 0.573456,
    "Faulty Coordination & Subordination": 0.286572,
    "Fragments & Fused Sentences": 0.328917,
    "Misplaced Modifiers": 0.615904,
    Parallelism: null,
    "Participial Phrases": 0.669167,
    "Relative Pronouns": 0.7003,
    "Verb Tense & Pronoun Person": 0.522446,
    "Adjectives & Adverbs": 0.690418,
    "Comparatives & Superlatives": 0.730683,
    "Confusing Pairs": 0.450863,
    "Forming Verbs": 0.347882,
    Idiom: 0.440123,
    Prepositions: 0.463488,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.579411,
    "Subject-Verb Agreement": 0.463158,
    Conjunctions: 0.388447,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.527078,
    "Word Choice": 0.319048,
    "Introductions & Conclusions": 0.457766,
    "Paragraph Division": 0.239918,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.588896,
    "Sentence Sequence": 0.348978,
    Transitions: 0.395327,
    "Accomplish Purpose": 0.286478,
    "Author's Purpose": 0.452984,
    Relevance: 0.300075,
    "Writer's Goal": 0.618903
  },
  scale16: {
    "Ambiguity & Series": 0.438997,
    Apostrophes: 0.608466,
    "Colons & Semicolons": 0.41475,
    "Parenthetical Elements": 0.31944,
    "Unnecessary Commas": 0.622235,
    "Faulty Coordination & Subordination": 0.274696,
    "Fragments & Fused Sentences": 0.350164,
    "Misplaced Modifiers": 0.663058,
    Parallelism: null,
    "Participial Phrases": 0.760487,
    "Relative Pronouns": 0.721245,
    "Verb Tense & Pronoun Person": 0.572125,
    "Adjectives & Adverbs": 0.792461,
    "Comparatives & Superlatives": 0.768606,
    "Confusing Pairs": 0.456976,
    "Forming Verbs": 0.403877,
    Idiom: 0.451244,
    Prepositions: 0.452982,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.559664,
    "Subject-Verb Agreement": 0.511059,
    Conjunctions: 0.455366,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.58249,
    "Word Choice": 0.344252,
    "Introductions & Conclusions": 0.471045,
    "Paragraph Division": 0.205822,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.655577,
    "Sentence Sequence": 0.388275,
    Transitions: 0.411338,
    "Accomplish Purpose": 0.266123,
    "Author's Purpose": 0.507901,
    Relevance: 0.396482,
    "Writer's Goal": 0.725219
  },
  scale17: {
    "Ambiguity & Series": 0.453927,
    Apostrophes: 0.641556,
    "Colons & Semicolons": 0.454141,
    "Parenthetical Elements": 0.339404,
    "Unnecessary Commas": 0.650016,
    "Faulty Coordination & Subordination": 0.334702,
    "Fragments & Fused Sentences": 0.390159,
    "Misplaced Modifiers": 0.708419,
    Parallelism: null,
    "Participial Phrases": 0.786448,
    "Relative Pronouns": 0.73614,
    "Verb Tense & Pronoun Person": 0.63214,
    "Adjectives & Adverbs": 0.826435,
    "Comparatives & Superlatives": 0.841889,
    "Confusing Pairs": 0.499483,
    "Forming Verbs": 0.458009,
    Idiom: 0.483444,
    Prepositions: 0.503053,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.591422,
    "Subject-Verb Agreement": 0.558085,
    Conjunctions: 0.467446,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.617136,
    "Word Choice": 0.384339,
    "Introductions & Conclusions": 0.496844,
    "Paragraph Division": 0.22589,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.671875,
    "Sentence Sequence": 0.435068,
    Transitions: 0.452159,
    "Accomplish Purpose": 0.288856,
    "Author's Purpose": 0.543315,
    Relevance: 0.392197,
    "Writer's Goal": 0.74136
  },
  scale18: {
    "Ambiguity & Series": 0.474714,
    Apostrophes: 0.667358,
    "Colons & Semicolons": 0.433624,
    "Parenthetical Elements": 0.346853,
    "Unnecessary Commas": 0.678641,
    "Faulty Coordination & Subordination": 0.247093,
    "Fragments & Fused Sentences": 0.408941,
    "Misplaced Modifiers": 0.764535,
    Parallelism: null,
    "Participial Phrases": 0.834302,
    "Relative Pronouns": 0.731105,
    "Verb Tense & Pronoun Person": 0.674738,
    "Adjectives & Adverbs": 0.850411,
    "Comparatives & Superlatives": 0.767442,
    "Confusing Pairs": 0.502114,
    "Forming Verbs": 0.437115,
    Idiom: 0.526348,
    Prepositions: 0.522871,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.596914,
    "Subject-Verb Agreement": 0.5751,
    Conjunctions: 0.505709,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.645157,
    "Word Choice": 0.408667,
    "Introductions & Conclusions": 0.538912,
    "Paragraph Division": 0.224811,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.726397,
    "Sentence Sequence": 0.46859,
    Transitions: 0.474766,
    "Accomplish Purpose": 0.31648,
    "Author's Purpose": 0.581459,
    Relevance: 0.462209,
    "Writer's Goal": 0.764455
  },
  scale19: {
    "Ambiguity & Series": 0.496471,
    Apostrophes: 0.676067,
    "Colons & Semicolons": 0.455592,
    "Parenthetical Elements": 0.389804,
    "Unnecessary Commas": 0.701936,
    "Faulty Coordination & Subordination": 0.388158,
    "Fragments & Fused Sentences": 0.449906,
    "Misplaced Modifiers": 0.756579,
    Parallelism: null,
    "Participial Phrases": 0.842105,
    "Relative Pronouns": 0.782895,
    "Verb Tense & Pronoun Person": 0.708066,
    "Adjectives & Adverbs": 0.875522,
    "Comparatives & Superlatives": 0.746711,
    "Confusing Pairs": 0.518719,
    "Forming Verbs": 0.53042,
    Idiom: 0.55744,
    Prepositions: 0.559264,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.615373,
    "Subject-Verb Agreement": 0.605052,
    Conjunctions: 0.535529,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.651218,
    "Word Choice": 0.440292,
    "Introductions & Conclusions": 0.578148,
    "Paragraph Division": 0.235973,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.74963,
    "Sentence Sequence": 0.502909,
    Transitions: 0.491957,
    "Accomplish Purpose": 0.311656,
    "Author's Purpose": 0.605936,
    Relevance: 0.598684,
    "Writer's Goal": 0.794547
  },
  scale20: {
    "Ambiguity & Series": 0.550739,
    Apostrophes: 0.71988,
    "Colons & Semicolons": 0.486387,
    "Parenthetical Elements": 0.406877,
    "Unnecessary Commas": 0.739888,
    "Faulty Coordination & Subordination": 0.342163,
    "Fragments & Fused Sentences": 0.500483,
    "Misplaced Modifiers": 0.766004,
    Parallelism: null,
    "Participial Phrases": 0.87638,
    "Relative Pronouns": 0.784768,
    "Verb Tense & Pronoun Person": 0.757912,
    "Adjectives & Adverbs": 0.904159,
    "Comparatives & Superlatives": 0.715232,
    "Confusing Pairs": 0.579945,
    "Forming Verbs": 0.529365,
    Idiom: 0.620963,
    Prepositions: 0.60766,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.665031,
    "Subject-Verb Agreement": 0.652058,
    Conjunctions: 0.56288,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.681472,
    "Word Choice": 0.492503,
    "Introductions & Conclusions": 0.624075,
    "Paragraph Division": 0.300719,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.769016,
    "Sentence Sequence": 0.552569,
    Transitions: 0.545964,
    "Accomplish Purpose": 0.365841,
    "Author's Purpose": 0.631692,
    Relevance: 0.611479,
    "Writer's Goal": 0.810804
  },
  scale21: {
    "Ambiguity & Series": 0.587961,
    Apostrophes: 0.77474,
    "Colons & Semicolons": 0.523748,
    "Parenthetical Elements": 0.431958,
    "Unnecessary Commas": 0.757755,
    "Faulty Coordination & Subordination": 0.404145,
    "Fragments & Fused Sentences": 0.53838,
    "Misplaced Modifiers": 0.831606,
    Parallelism: null,
    "Participial Phrases": 0.860104,
    "Relative Pronouns": 0.814767,
    "Verb Tense & Pronoun Person": 0.810924,
    "Adjectives & Adverbs": 0.902128,
    "Comparatives & Superlatives": 0.795337,
    "Confusing Pairs": 0.621096,
    "Forming Verbs": 0.578161,
    Idiom: 0.678415,
    Prepositions: 0.662235,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.684811,
    "Subject-Verb Agreement": 0.692922,
    Conjunctions: 0.601254,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.698796,
    "Word Choice": 0.534444,
    "Introductions & Conclusions": 0.642105,
    "Paragraph Division": 0.372507,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.810485,
    "Sentence Sequence": 0.609996,
    Transitions: 0.593035,
    "Accomplish Purpose": 0.429199,
    "Author's Purpose": 0.664417,
    Relevance: 0.65285,
    "Writer's Goal": 0.834943
  },
  scale22: {
    "Ambiguity & Series": 0.616359,
    Apostrophes: 0.805685,
    "Colons & Semicolons": 0.523927,
    "Parenthetical Elements": 0.485575,
    "Unnecessary Commas": 0.780583,
    "Faulty Coordination & Subordination": 0.425743,
    "Fragments & Fused Sentences": 0.577959,
    "Misplaced Modifiers": 0.836634,
    Parallelism: null,
    "Participial Phrases": 0.950495,
    "Relative Pronouns": 0.804455,
    "Verb Tense & Pronoun Person": 0.826156,
    "Adjectives & Adverbs": 0.936218,
    "Comparatives & Superlatives": 0.792079,
    "Confusing Pairs": 0.620775,
    "Forming Verbs": 0.650538,
    Idiom: 0.709801,
    Prepositions: 0.711073,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.716377,
    "Subject-Verb Agreement": 0.723766,
    Conjunctions: 0.621977,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.733878,
    "Word Choice": 0.577323,
    "Introductions & Conclusions": 0.682223,
    "Paragraph Division": 0.390751,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.829444,
    "Sentence Sequence": 0.669283,
    Transitions: 0.630703,
    "Accomplish Purpose": 0.464998,
    "Author's Purpose": 0.677599,
    Relevance: 0.762376,
    "Writer's Goal": 0.841218
  },
  scale23: {
    "Ambiguity & Series": 0.656607,
    Apostrophes: 0.838462,
    "Colons & Semicolons": 0.569149,
    "Parenthetical Elements": 0.498632,
    "Unnecessary Commas": 0.806325,
    "Faulty Coordination & Subordination": 0.521277,
    "Fragments & Fused Sentences": 0.616923,
    "Misplaced Modifiers": 0.808511,
    Parallelism: null,
    "Participial Phrases": 0.943262,
    "Relative Pronouns": 0.819149,
    "Verb Tense & Pronoun Person": 0.862479,
    "Adjectives & Adverbs": 0.948946,
    "Comparatives & Superlatives": 0.843972,
    "Confusing Pairs": 0.6751,
    "Forming Verbs": 0.659466,
    Idiom: 0.729744,
    Prepositions: 0.752821,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.734402,
    "Subject-Verb Agreement": 0.766439,
    Conjunctions: 0.659077,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.758034,
    "Word Choice": 0.614444,
    "Introductions & Conclusions": 0.712821,
    "Paragraph Division": 0.463419,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.864444,
    "Sentence Sequence": 0.713077,
    Transitions: 0.669493,
    "Accomplish Purpose": 0.51812,
    "Author's Purpose": 0.706325,
    Relevance: 0.762411,
    "Writer's Goal": 0.858718
  },
  scale24: {
    "Ambiguity & Series": 0.69815,
    Apostrophes: 0.85396,
    "Colons & Semicolons": 0.616977,
    "Parenthetical Elements": 0.536913,
    "Unnecessary Commas": 0.832953,
    "Faulty Coordination & Subordination": 0.552795,
    "Fragments & Fused Sentences": 0.656779,
    "Misplaced Modifiers": 0.751553,
    Parallelism: null,
    "Participial Phrases": 0.925466,
    "Relative Pronouns": 0.850932,
    "Verb Tense & Pronoun Person": 0.880805,
    "Adjectives & Adverbs": 0.962506,
    "Comparatives & Superlatives": 0.925466,
    "Confusing Pairs": 0.700582,
    "Forming Verbs": 0.644596,
    Idiom: 0.738255,
    Prepositions: 0.769396,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.730537,
    "Subject-Verb Agreement": 0.799687,
    Conjunctions: 0.695839,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.778389,
    "Word Choice": 0.657886,
    "Introductions & Conclusions": 0.717718,
    "Paragraph Division": 0.513289,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.879463,
    "Sentence Sequence": 0.743758,
    Transitions: 0.699508,
    "Accomplish Purpose": 0.541745,
    "Author's Purpose": 0.726336,
    Relevance: 0.826087,
    "Writer's Goal": 0.881208
  },
  scale25: {
    "Ambiguity & Series": 0.720231,
    Apostrophes: 0.861031,
    "Colons & Semicolons": 0.59596,
    "Parenthetical Elements": 0.587736,
    "Unnecessary Commas": 0.858149,
    "Faulty Coordination & Subordination": 0.568182,
    "Fragments & Fused Sentences": 0.699167,
    "Misplaced Modifiers": 0.871212,
    Parallelism: null,
    "Participial Phrases": 0.94697,
    "Relative Pronouns": 0.833333,
    "Verb Tense & Pronoun Person": 0.899776,
    "Adjectives & Adverbs": 0.959334,
    "Comparatives & Superlatives": 0.893939,
    "Confusing Pairs": 0.729961,
    "Forming Verbs": 0.699422,
    Idiom: 0.747679,
    Prepositions: 0.795229,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.769292,
    "Subject-Verb Agreement": 0.823727,
    Conjunctions: 0.715082,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.780019,
    "Word Choice": 0.683998,
    "Introductions & Conclusions": 0.754083,
    "Paragraph Division": 0.581492,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.915466,
    "Sentence Sequence": 0.754083,
    Transitions: 0.73186,
    "Accomplish Purpose": 0.584214,
    "Author's Purpose": 0.747038,
    Relevance: 0.757576,
    "Writer's Goal": 0.881044
  },
  scale26: {
    "Ambiguity & Series": 0.753485,
    Apostrophes: 0.902108,
    "Colons & Semicolons": 0.651235,
    "Parenthetical Elements": 0.630225,
    "Unnecessary Commas": 0.867006,
    "Faulty Coordination & Subordination": 0.675926,
    "Fragments & Fused Sentences": 0.730261,
    "Misplaced Modifiers": 0.935185,
    Parallelism: null,
    "Participial Phrases": 0.944444,
    "Relative Pronouns": 0.861111,
    "Verb Tense & Pronoun Person": 0.922651,
    "Adjectives & Adverbs": 0.978802,
    "Comparatives & Superlatives": 0.944444,
    "Confusing Pairs": 0.728713,
    "Forming Verbs": 0.759189,
    Idiom: 0.798142,
    Prepositions: 0.843516,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.783583,
    "Subject-Verb Agreement": 0.815648,
    Conjunctions: 0.762272,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.795105,
    "Word Choice": 0.717578,
    "Introductions & Conclusions": 0.78278,
    "Paragraph Division": 0.584494,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.932833,
    "Sentence Sequence": 0.814041,
    Transitions: 0.750292,
    "Accomplish Purpose": 0.641122,
    "Author's Purpose": 0.76263,
    Relevance: 0.805556,
    "Writer's Goal": 0.889782
  },
  scale27: {
    "Ambiguity & Series": 0.764706,
    Apostrophes: 0.932521,
    "Colons & Semicolons": 0.741497,
    "Parenthetical Elements": 0.682755,
    "Unnecessary Commas": 0.892299,
    "Faulty Coordination & Subordination": 0.877551,
    "Fragments & Fused Sentences": 0.770853,
    "Misplaced Modifiers": 0.918367,
    Parallelism: null,
    "Participial Phrases": 0.897959,
    "Relative Pronouns": 0.836735,
    "Verb Tense & Pronoun Person": 0.961575,
    "Adjectives & Adverbs": 0.982037,
    "Comparatives & Superlatives": 0.857143,
    "Confusing Pairs": 0.713683,
    "Forming Verbs": 0.797214,
    Idiom: 0.856607,
    Prepositions: 0.86059,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.774719,
    "Subject-Verb Agreement": 0.831928,
    Conjunctions: 0.79597,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.821462,
    "Word Choice": 0.74344,
    "Introductions & Conclusions": 0.797798,
    "Paragraph Division": 0.612933,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.929709,
    "Sentence Sequence": 0.836223,
    Transitions: 0.765604,
    "Accomplish Purpose": 0.680881,
    "Author's Purpose": 0.781724,
    Relevance: 0.938776,
    "Writer's Goal": 0.900422
  },
  scale28: {
    "Ambiguity & Series": 0.807155,
    Apostrophes: 0.966514,
    "Colons & Semicolons": 0.714286,
    "Parenthetical Elements": 0.722476,
    "Unnecessary Commas": 0.919373,
    "Faulty Coordination & Subordination": 0.666667,
    "Fragments & Fused Sentences": 0.808727,
    "Misplaced Modifiers": 0.793651,
    Parallelism: null,
    "Participial Phrases": 0.984127,
    "Relative Pronouns": 0.912698,
    "Verb Tense & Pronoun Person": 0.971588,
    "Adjectives & Adverbs": 0.974801,
    "Comparatives & Superlatives": 0.714286,
    "Confusing Pairs": 0.772028,
    "Forming Verbs": 0.818499,
    Idiom: 0.845764,
    Prepositions: 0.894977,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.826611,
    "Subject-Verb Agreement": 0.847708,
    Conjunctions: 0.828412,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.855657,
    "Word Choice": 0.763762,
    "Introductions & Conclusions": 0.828006,
    "Paragraph Division": 0.677321,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.936073,
    "Sentence Sequence": 0.859209,
    Transitions: 0.803213,
    "Accomplish Purpose": 0.719432,
    "Author's Purpose": 0.804972,
    Relevance: 0.936508,
    "Writer's Goal": 0.912227
  },
  scale29: {
    "Ambiguity & Series": 0.838057,
    Apostrophes: 0.934349,
    "Colons & Semicolons": 0.714286,
    "Parenthetical Elements": 0.752638,
    "Unnecessary Commas": 0.939918,
    "Faulty Coordination & Subordination": 0.857143,
    "Fragments & Fused Sentences": 0.842321,
    "Misplaced Modifiers": 0.928571,
    Parallelism: null,
    "Participial Phrases": 1.0,
    "Relative Pronouns": 0.892857,
    "Verb Tense & Pronoun Person": 0.979484,
    "Adjectives & Adverbs": 0.972255,
    "Comparatives & Superlatives": 0.928571,
    "Confusing Pairs": 0.814381,
    "Forming Verbs": 0.809717,
    Idiom: 0.89449,
    Prepositions: 0.883353,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.845838,
    "Subject-Verb Agreement": 0.903869,
    Conjunctions: 0.846659,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.875733,
    "Word Choice": 0.813159,
    "Introductions & Conclusions": 0.820633,
    "Paragraph Division": 0.758499,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.948417,
    "Sentence Sequence": 0.843494,
    Transitions: 0.83728,
    "Accomplish Purpose": 0.752638,
    "Author's Purpose": 0.839859,
    Relevance: 1.0,
    "Writer's Goal": 0.924971
  },
  scale30: {
    "Ambiguity & Series": 0.813596,
    Apostrophes: 0.955224,
    "Colons & Semicolons": 0.733333,
    "Parenthetical Elements": 0.778607,
    "Unnecessary Commas": 0.93978,
    "Faulty Coordination & Subordination": 0.7,
    "Fragments & Fused Sentences": 0.876244,
    "Misplaced Modifiers": 0.966667,
    Parallelism: null,
    "Participial Phrases": 1.0,
    "Relative Pronouns": 0.9,
    "Verb Tense & Pronoun Person": 0.981343,
    "Adjectives & Adverbs": 0.981758,
    "Comparatives & Superlatives": 0.866667,
    "Confusing Pairs": 0.814677,
    "Forming Verbs": 0.881579,
    Idiom: 0.84204,
    Prepositions: 0.871891,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.847015,
    "Subject-Verb Agreement": 0.888474,
    Conjunctions: 0.8301,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.860697,
    "Word Choice": 0.824316,
    "Introductions & Conclusions": 0.884328,
    "Paragraph Division": 0.768657,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.95398,
    "Sentence Sequence": 0.848259,
    Transitions: 0.845025,
    "Accomplish Purpose": 0.777985,
    "Author's Purpose": 0.843532,
    Relevance: 1.0,
    "Writer's Goal": 0.930348
  },
  scale31: {
    "Ambiguity & Series": 0.858639,
    Apostrophes: 0.990868,
    "Colons & Semicolons": 0.777778,
    "Parenthetical Elements": 0.792998,
    "Unnecessary Commas": 0.951167,
    "Faulty Coordination & Subordination": 0.809524,
    "Fragments & Fused Sentences": 0.882801,
    "Misplaced Modifiers": 1.0,
    Parallelism: null,
    "Participial Phrases": 1.0,
    "Relative Pronouns": 0.857143,
    "Verb Tense & Pronoun Person": 0.957382,
    "Adjectives & Adverbs": 0.993404,
    "Comparatives & Superlatives": 0.904762,
    "Confusing Pairs": 0.836631,
    "Forming Verbs": 0.837696,
    Idiom: 0.893455,
    Prepositions: 0.909437,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.872146,
    "Subject-Verb Agreement": 0.880771,
    Conjunctions: 0.833486,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.923135,
    "Word Choice": 0.816781,
    "Introductions & Conclusions": 0.87519,
    "Paragraph Division": 0.774734,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.95586,
    "Sentence Sequence": 0.917047,
    Transitions: 0.838661,
    "Accomplish Purpose": 0.781583,
    "Author's Purpose": 0.863927,
    Relevance: 0.952381,
    "Writer's Goal": 0.932268
  },
  scale32: {
    "Ambiguity & Series": 0.84104,
    Apostrophes: 0.97561,
    "Colons & Semicolons": 0.798611,
    "Parenthetical Elements": 0.850407,
    "Unnecessary Commas": 0.942141,
    "Faulty Coordination & Subordination": 0.625,
    "Fragments & Fused Sentences": 0.886992,
    "Misplaced Modifiers": 1.0,
    Parallelism: null,
    "Participial Phrases": 1.0,
    "Relative Pronouns": 0.875,
    "Verb Tense & Pronoun Person": 0.980488,
    "Adjectives & Adverbs": 0.969648,
    "Comparatives & Superlatives": 0.875,
    "Confusing Pairs": 0.815176,
    "Forming Verbs": 0.884393,
    Idiom: 0.886179,
    Prepositions: 0.911382,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.867073,
    "Subject-Verb Agreement": 0.885908,
    Conjunctions: 0.88,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.878862,
    "Word Choice": 0.852033,
    "Introductions & Conclusions": 0.907317,
    "Paragraph Division": 0.778862,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.949593,
    "Sentence Sequence": 0.884553,
    Transitions: 0.857886,
    "Accomplish Purpose": 0.830081,
    "Author's Purpose": 0.867967,
    Relevance: 0.916667,
    "Writer's Goal": 0.933333
  },
  scale33: {
    "Ambiguity & Series": 0.864516,
    Apostrophes: 0.96381,
    "Colons & Semicolons": 0.922222,
    "Parenthetical Elements": 0.879048,
    "Unnecessary Commas": 0.943968,
    "Faulty Coordination & Subordination": 1.0,
    "Fragments & Fused Sentences": 0.92,
    "Misplaced Modifiers": 1.0,
    Parallelism: null,
    "Participial Phrases": 1.0,
    "Relative Pronouns": 0.966667,
    "Verb Tense & Pronoun Person": 0.985714,
    "Adjectives & Adverbs": 0.986032,
    "Comparatives & Superlatives": 1.0,
    "Confusing Pairs": 0.831746,
    "Forming Verbs": 0.864516,
    Idiom: 0.918095,
    Prepositions: 0.925714,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.890952,
    "Subject-Verb Agreement": 0.902857,
    Conjunctions: 0.896,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.90381,
    "Word Choice": 0.865714,
    "Introductions & Conclusions": 0.88,
    "Paragraph Division": 0.811429,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.965714,
    "Sentence Sequence": 0.905714,
    Transitions: 0.862857,
    "Accomplish Purpose": 0.841905,
    "Author's Purpose": 0.862095,
    Relevance: 0.866667,
    "Writer's Goal": 0.938095
  },
  scale34: {
    "Ambiguity & Series": 0.883598,
    Apostrophes: 0.97545,
    "Colons & Semicolons": 0.863636,
    "Parenthetical Elements": 0.914894,
    "Unnecessary Commas": 0.978451,
    "Faulty Coordination & Subordination": 0.545455,
    "Fragments & Fused Sentences": 0.92635,
    "Misplaced Modifiers": 1.0,
    Parallelism: null,
    "Participial Phrases": 1.0,
    "Relative Pronouns": 1.0,
    "Verb Tense & Pronoun Person": 0.984452,
    "Adjectives & Adverbs": 0.99509,
    "Comparatives & Superlatives": 1.0,
    "Confusing Pairs": 0.847791,
    "Forming Verbs": 0.89418,
    Idiom: 0.92635,
    Prepositions: 0.928805,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.917758,
    "Subject-Verb Agreement": 0.918985,
    Conjunctions: 0.902782,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.932079,
    "Word Choice": 0.881751,
    "Introductions & Conclusions": 0.900164,
    "Paragraph Division": 0.808511,
    "Paragraph Sequence": null,
    "Sentence Placement": 0.978723,
    "Sentence Sequence": 0.927987,
    Transitions: 0.913584,
    "Accomplish Purpose": 0.871522,
    "Author's Purpose": 0.894926,
    Relevance: 1.0,
    "Writer's Goal": 0.96563
  },
  scale35: {
    "Ambiguity & Series": 0.926471,
    Apostrophes: 0.993865,
    "Colons & Semicolons": 0.933333,
    "Parenthetical Elements": 0.946319,
    "Unnecessary Commas": 0.991309,
    "Faulty Coordination & Subordination": 1.0,
    "Fragments & Fused Sentences": 0.969325,
    "Misplaced Modifiers": 1.0,
    Parallelism: null,
    "Participial Phrases": 1.0,
    "Relative Pronouns": 1.0,
    "Verb Tense & Pronoun Person": 1.0,
    "Adjectives & Adverbs": 0.990798,
    "Comparatives & Superlatives": 1.0,
    "Confusing Pairs": 0.876278,
    "Forming Verbs": 0.941176,
    Idiom: 0.944785,
    Prepositions: 0.944785,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 0.96089,
    "Subject-Verb Agreement": 0.936094,
    Conjunctions: 0.939264,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 0.96319,
    "Word Choice": 0.941334,
    "Introductions & Conclusions": 0.940184,
    "Paragraph Division": 0.825153,
    "Paragraph Sequence": null,
    "Sentence Placement": 1.0,
    "Sentence Sequence": 0.96319,
    Transitions: 0.933742,
    "Accomplish Purpose": 0.909509,
    "Author's Purpose": 0.942331,
    Relevance: 1.0,
    "Writer's Goal": 1.0
  },
  scale36: {
    "Ambiguity & Series": 1.0,
    Apostrophes: 1.0,
    "Colons & Semicolons": 1.0,
    "Parenthetical Elements": 1.0,
    "Unnecessary Commas": 1.0,
    "Faulty Coordination & Subordination": 1.0,
    "Fragments & Fused Sentences": 1.0,
    "Misplaced Modifiers": 1.0,
    Parallelism: null,
    "Participial Phrases": 1.0,
    "Relative Pronouns": 1.0,
    "Verb Tense & Pronoun Person": 1.0,
    "Adjectives & Adverbs": 1.0,
    "Comparatives & Superlatives": 1.0,
    "Confusing Pairs": 1.0,
    "Forming Verbs": 1.0,
    Idiom: 1.0,
    Prepositions: 1.0,
    "Pronoun-Antecedent Agreement": null,
    Pronouns: 1.0,
    "Subject-Verb Agreement": 1.0,
    Conjunctions: 1.0,
    Redundancy: null,
    "Style & Tone": null,
    "Vague & Clumsy Writing": 1.0,
    "Word Choice": 1.0,
    "Introductions & Conclusions": 1.0,
    "Paragraph Division": 1.0,
    "Paragraph Sequence": null,
    "Sentence Placement": 1.0,
    "Sentence Sequence": 1.0,
    Transitions: 1.0,
    "Accomplish Purpose": 1.0,
    "Author's Purpose": 1.0,
    Relevance: 1.0,
    "Writer's Goal": 1.0
  }
}

export default tsDataEnglish
